import { MuiTelInput, MuiTelInputProps } from 'mui-tel-input'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

export type TelInputProps<T extends FieldValues> = MuiTelInputProps & UseControllerProps<T> & { maxLength?: number }

export const TelInput = <T extends FieldValues>({
  control,
  name,
  onBlur,
  defaultValue,
  rules,
  disabled,
  variant = 'outlined',
  ...rest
}: TelInputProps<T>) => {
  const {
    field: { value, ref, onChange: onFieldChange, onBlur: onFieldBlur, ...field },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  })

  const handleChange = (inputValue: string) => {
    onFieldChange(inputValue)
  }

  return (
    <MuiTelInput
      value={value}
      error={!!error}
      fullWidth
      onChange={handleChange}
      onBlur={(event) => {
        onFieldBlur()

        if (onBlur) {
          onBlur(event)
        }
      }}
      variant={variant}
      disabled={disabled}
      inputRef={ref}
      {...field}
      {...rest}
    />
  )
}
